import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import AboutCompany from '../Elements/AboutCompany';
import OurServices3 from '../Elements/OurServices3';
import OurValue3 from '../Elements/OurValue3';
import Faq from '../Elements/Faq';

var bnrimg = require('./../../images/banner/2.jpg');

class Services extends React.Component {
    render() {
        return (
            <>

                <Header />
                <div className="page-content">
                    <Banner title="Varied services. Consistent quality!" pagename="Services" bgimage={bnrimg}/>
                    <AboutCompany />
                    <OurServices3 />
                    <OurValue3 />
                    <Faq />
                <Footer />
                    
                </div>

                
               

            </>
        );
    };
};

export default Services;